import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface TaxContraventionItem {
  publish_time: string
  case_type: string
  department: string
  taxpayer_name: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const normalizeItems = (items: TaxContraventionItem[] = []) =>
  items.map((item) => ({
    type: item.case_type || '—',
    department: item.department || '—',
    publishDate: item.publish_time ? dayjs(item.publish_time).format('YYYY-MM-DD') : '—',
    taxpayer: item.taxpayer_name || '—',
  }))

export default function TianyanchaTaxContravention({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_taxContravention ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const records = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          税务违法记录
        </Text>
        <Stack gap="sm" className="mt-3">
          {records.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无税务违法记录
            </Text>
          ) : (
            records.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.type}-${index}`}
                number={index + 1}
                recordType="违法记录"
                fields={[
                  { label: '违规类型', value: item.type },
                  { label: '执法单位', value: item.department },
                  { label: '发布日期', value: item.publishDate },
                  { label: '纳税人名称', value: item.taxpayer },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
